<template>
  <section class="bg-white">
    <div class="container px-[15px] pt-[30px] pb-[60px] mx-auto">
      <ValidationObserver ref="formObserver">
        <form v-on:submit.prevent="onSubmit">
          <div class="font-primary font-semibold text-[38px] text-curious-blue pb-[30px]">{{ contact_title }}</div>
          <div class="grid grid-cols-12 gap-y-[30px] gap-x-[15px] pb-[10px]">
            <div class="col-span-6 flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%]">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-[20px] h-[20px] text-allports ml-[20px]" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/>
              </svg>
              <ValidationProvider rules="name_required" v-slot="{ errors }" class="w-full h-full">
                <input v-model="name" v-bind:placeholder="errors.length ? $t(errors[0]) : contact_placeholder_1" class="font-primary font-light text-[14px] text-dove-gray w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" type="text">
              </ValidationProvider>
            </div>
            <div class="col-span-6 flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%]">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-[20px] h-[20px] text-allports ml-[20px]" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
              </svg>
              <ValidationProvider rules="email_required|email_valid" v-slot="{ errors }" class="w-full h-full">
                <input v-model="email" v-bind:placeholder="errors.length ? $t(errors[0]) : contact_placeholder_2" class="font-primary font-light text-[14px] text-dove-gray w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" type="email">
              </ValidationProvider>
            </div>
            <div class="col-span-12 bg-timberwolf bg-opacity-[20%]">
              <ValidationProvider rules="message_required" v-slot="{ errors }" class="w-full h-full">
                <textarea v-model="message" v-bind:placeholder="errors.length ? $t(errors[0]) : contact_placeholder_3" class="font-primary font-light text-[14px] text-dove-gray w-full h-full bg-transparent border-none rounded-none p-[20px] focus:outline-none focus-within:outline-none" rows="5"></textarea>
              </ValidationProvider>
            </div>
          </div>
          <button type="submit" class="flex items-center justify-center font-primary text-[14px] text-white w-full bg-allports py-[15px] border-none rounded-none outline-none">
            <svg v-if="loading" class="animate-spin ml-[5px] w-[20px] h-[20px] mr-[10px]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ contact_label }}
          </button>
        </form>
      </ValidationObserver>
    </div>
  </section>
</template>
<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import axios from 'axios';

extend('name_required', {
  ...required,
  message: 'message.contact_error_1'
});

extend('email_required', {
  ...required,
  message: 'message.contact_error_2'
});

extend('email_valid', {
  ...email,
  message: 'message.contact_error_3'
});

extend('message_required', {
  ...required,
  message: 'message.contact_error_4'
});

export default {
  name: 'ContactForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      wp_ajax: window.contact_script_data.wp_ajax,
      wp_nonce: window.contact_script_data.wp_nonce,
      contact_title: window.contact_script_data.contact_title,
      contact_placeholder_1: window.contact_script_data.contact_placeholder_1,
      contact_placeholder_2: window.contact_script_data.contact_placeholder_2,
      contact_placeholder_3: window.contact_script_data.contact_placeholder_3,
      contact_error_1: window.contact_script_data.contact_error_1,
      contact_error_2: window.contact_script_data.contact_error_2,
      contact_error_3: window.contact_script_data.contact_error_3,
      contact_error_4: window.contact_script_data.contact_error_4,
      contact_label: window.contact_script_data.contact_label,
      name: '',
      email: '',
      message: '',
      recaptcha_token: '',
      loading: false,
    };
  },
  methods: {
    async onSubmit () {
      await this.$recaptchaLoaded();
      this.recaptcha_token = await this.$recaptcha('submit_contact_form');
      this.$refs.formObserver.validate().then(success => {
        if (success) {
          this.loading = true;
          let formData = new FormData();
          formData.append('wp_nonce', this.wp_nonce);
          formData.append('action', 'submit_contact_form');
          formData.append('name', this.name);
          formData.append('email', this.email);
          formData.append('message', this.message);
          formData.append('recaptcha_token', this.recaptcha_token);
          axios({
            method: 'POST',
            url: this.wp_ajax,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData,
          }).then(response => {
            if (response.data.status === 1) {
              this.$swal('Sent', response.data.message, 'success');
              this.name = this.email = this.message = '';
              this.$nextTick(() => {
                this.$refs.formObserver.reset();
              });
            } else {
              this.$swal('Error', response.data.message, 'error');
            }
            this.loading = false;
          });
        }
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="scss">
</style>
